/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */

App.FormErrors = class FormErrors {

  constructor(json, options = {}) {
    this.close = this.close.bind(this);
    this.json  = json;
    this.scope = options.scope;

    $(document)
      .off('click', '.js-form-errors-close', this.close)
      .on('click', '.js-form-errors-close', this.close);

    this.render();
  }

  close(evt) {
    return $(evt.target).closest('.js-form-errors').html('');
  }

  static clear_all() {
    return $(".js-form-errors").html("");
  }

  // Translate devise's flash alerts into inline form errors
  static for_sign_in() {
    const msg = $(".js-form-errors[data-alert]").attr("data-alert");
    if (msg != null) {
      return new App.FormErrors({
        class_name: "user",
        id: "null",
        errors: { " ": msg }});
    }
  }

  render() {
    const container = $(`.js-form-errors--${this.json.class_name}-${this.json.id || "null"}`);
    const scope = container.data("scope");
    // console.log "container: ", container
    const {
      attr_map
    } = this.json;

    let errors = "";
    for (var k in this.json.errors) {
      // console.log "k: ", k
      // console.log "v: ", v
      var v = this.json.errors[k];
      var name = (k[0].toUpperCase() + k.slice(1)).replace(/_/g, " ");
      if (attr_map) { name = attr_map[k]; }
      if (name === "Base") { name = ""; }

      if (v.length > 0) { errors += `<div class='form-errors__msg'>${name} ${v.join(", ")}</div>`; }
    }

    if (!!errors) {
      const target = (this.scope != null) ? $(`${this.scope} .js-form-errors`) : container;
      target.html(`\
<div class="form-errors__inner"> \
<span class="form-errors-close icon--close-x red js-form-errors-close"></span> \
<div class="form-errors__title">Please fix this:</div>\
`+errors+`\
</div>\
`
      );
      window.setTimeout((() => target.find(".form-errors__inner").addClass("active")), 100);

      // If we're in a modal, scroll to top of it
      return container.closest(".modal").scrollTop(0);
    }
  }
};
